import { render, staticRenderFns } from "./orderUpdate.vue?vue&type=template&id=f44719b6&scoped=true&"
import script from "./orderUpdate.vue?vue&type=script&lang=js&"
export * from "./orderUpdate.vue?vue&type=script&lang=js&"
import style0 from "./orderUpdate.vue?vue&type=style&index=0&id=f44719b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44719b6",
  null
  
)

export default component.exports